import { render, staticRenderFns } from "./UserCoreComplianceViolationsSelect.vue?vue&type=template&id=32710e1f"
import script from "./UserCoreComplianceViolationsSelect.vue?vue&type=script&lang=js"
export * from "./UserCoreComplianceViolationsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports